<template>
  <div>
    <div class="row">
      <div class="col-sm-4 mb-2">
        <button
          v-if="permission.permissions.includes('add')"
          class="btn btn-info btn-sm"
          @click="create = true"
        >
          {{ $t('manage-master-data.create') }}
        </button>
      </div>
      <div class="col-sm-4 d-flex align-items-center justify-content-center mb-2">
        <small>{{ $t('pagination.show') }}</small>
        <select
          v-model="pagination.PageSize"
          class="form-control form-control-sm w-auto mx-2"
        >
          <option
            v-for="(size, s) in pageSizes"
            :key="s"
            :value="size"
          >
            {{ size }}
          </option>
        </select>
        <small>{{ $t('pagination.entries') }}</small>
      </div>
    </div>

    <data-table
      class="my-3"
      :fields="fields"
      :data="workLocations"
    >
      <template #action="{ rowData }">
        <a
          v-if="permission.permissions.includes('edit')"
          class="text-info mx-2"
          :title="rowData.id"
          @click="editWorkLocation(rowData)"
        >
          <i class="fa fa-edit fa-lg" />
        </a>
        <a
          v-if="permission.permissions.includes('delete')"
          class="text-danger mx-2"
          :title="rowData.id"
          @click="confirmDelete(rowData)"
        >
          <i class="fa fa-trash fa-lg" />
        </a>
      </template>

      <template #coordinate="{ rowData }">
        <div v-if="rowData.latitude && rowData.longitude">
          {{ rowData.latitude }}, {{ rowData.longitude }}
        </div>
      </template>

      <template #isShow="{ rowData }">
        <toggle-button
          :value="rowData.isShow"
          color="#18B2BD"
          sync
          @input="update(rowData, { isShow: !rowData.isShow })"
        />
      </template>

      <template #isOrganization="{ rowData }">
        <toggle-button
          :value="rowData.isOrganization"
          color="#18B2BD"
          sync
          @input="update(rowData, { isOrganization: !rowData.isOrganization })"
        />
      </template>
    </data-table>

    <div class="d-flex flex-wrap justify-content-center justify-content-sm-between">
      <div class="mb-2">
        <pagination-info
          :page="workLocations.currentPage"
          :page-size="workLocations.pageSize"
          :shown="workLocations.data.length"
          :total="workLocations.totalData"
        />
      </div>

      <pagination
        ref="pagination"
        class="mb-2"
        @change="onPageChange"
      />
    </div>

    <create
      :shown="create"
      @close="create = false"
      @saved="saved"
    />

    <edit
      :shown="edit.modal"
      :work-location="edit.workLocation"
      @close="edit.modal = false"
      @saved="updated"
    />

    <modal
      :shown="success.modal"
      @close="success.modal = false"
    >
      <div class="p-5 text-center">
        {{ success.text }}
        <button
          class="btn btn-outline-info btn-sm mt-3"
          @click="success.modal = false"
        >
          OK
        </button>
      </div>
    </modal>

    <modal
      :shown="del.modal"
      @close="del.modal = false"
    >
      <div class="p-5 text-center">
        <div>
          {{ $t('manage-master-data.work-locations.confirm-delete', { name: del.workLocation.name }) }}
        </div>
        <button
          class="btn btn-link text-decoration-none btn-sm mt-3"
          @click="del.modal = false"
        >
          {{ $t('manage-master-data.work-locations.cancel') }}
        </button>
        <button
          class="btn btn-danger btn-sm mt-3"
          @click="deleteWorkLocation"
        >
          {{ $t('manage-master-data.work-locations.delete') }}
        </button>
      </div>
    </modal>
  </div>
</template>

<script>
import { ToggleButton } from 'vue-js-toggle-button'
import { PAGE_SIZES } from '@/fixtures'
import api from '@/utils/Api'
import DataTable from '@/components/DataTable'
import Modal from '@/components/Modal'
import PaginationInfo from '@/components/PaginationInfo'
import Pagination from '@/components/Pagination'
import Create from './WorkLocation/Create'
import Edit from './WorkLocation/Edit'

export default {
  components: {
    ToggleButton,
    DataTable,
    Modal,
    PaginationInfo,
    Pagination,
    Create,
    Edit
  },

  data: () => ({
    fields: [
      { name: 'action', title: 'Tindakan', titleClass: 'text-center', dataClass: 'text-center' },
      { name: 'name', title: 'Lokasi Kerja' },
      { name: 'coordinate', title: 'Koordinat' },
      { name: 'isShow', title: 'Ditampilkan?' },
      { name: 'isOrganization', title: 'Organisasi?' },
      { name: 'createdBy', title: 'Dibuat Oleh' }
    ],
    pagination: {
      Page: 1,
      PageSize: 10
    },
    workLocations: {
      data: []
    },
    create: false,
    edit: {
      modal: false,
      workLocation: {}
    },
    del: {
      modal: false,
      workLocation: {}
    },
    success: {
      modal: false,
      text: ''
    },
    permission: []
  }),

  computed: {
    pageSizes: () => PAGE_SIZES
  },

  watch: {
    'pagination.PageSize' () {
      this.pagination.Page = 1
      this.fetch()
    }
  },

  created () {
    this.getPermission()
    this.fetch()
  },

  methods: {
    getPermission () {
      const dataLoc = JSON.parse(localStorage.getItem('profile'))
      const index = dataLoc.role.permissions.findIndex(element => element.category === 'master_data')
      this.permission = dataLoc.role.permissions[index]
    },
    async fetch () {
      const { data } = await api.workLocations.list({
        ...this.pagination,
        Sorts: 'name'
      })
      this.workLocations = data
      this.$refs.pagination.setPaginationData({
        total: data.totalData,
        per_page: data.pageSize,
        current_page: data.currentPage,
        last_page: data.totalPage
      })
    },
    async update ({ id }, update) {
      await api.workLocations.update(id, update)
      const [key, value] = Object.entries(update)[0]
      this.workLocations.data
        .find((workLocation) => workLocation.id === id)[key] = value
    },
    async deleteWorkLocation () {
      await api.workLocations.delete(this.del.workLocation.id)
      this.del.modal = false
      this.success = {
        modal: true,
        text: this.$t(
          'manage-master-data.work-locations.success-delete',
          { name: this.del.workLocation.name }
        )
      }
      this.fetch()
    },
    editWorkLocation (workLocation) {
      this.edit = {
        modal: true,
        workLocation: { ...workLocation }
      }
    },
    saved () {
      this.fetch()
      this.create = false
      this.success = {
        modal: true,
        text: this.$t('manage-master-data.work-locations.success-add')
      }
    },
    updated () {
      this.fetch()
      this.edit.modal = false
      this.success = {
        modal: true,
        text: this.$t(
          'manage-master-data.work-locations.success-update',
          { name: this.edit.workLocation.name }
        )
      }
    },
    confirmDelete (workLocation) {
      this.del = {
        modal: true,
        workLocation
      }
    },
    onPageChange (page) {
      this.pagination.Page = page
      this.fetch()
    }
  }
}
</script>
